import { A } from "@solidjs/router";

export default () => {
	return (
		<div class="rias-content col-span-full">
			<h1>Membership Criteria and Routes to Membership</h1>

			<p>Membership of RIAS - Energy Design Certification Scheme is open to those who are:</p>

			<ul>
				<li>Registered with the Architects Registration Board (ARB), or</li>
				<li>
					A Chartered (MCIAT) Member of the Chartered Institute of Architectural
					Technologists (CIAT), or
				</li>
				<li>
					A Corporate Member of, or registered as a Low Carbon Consultant (LCC) with the
					Chartered Institution of Building Services Engineers (CIBSE), or
				</li>
				<li>
					<p>
						Other Construction Professionals who have suitable experience,
						qualifications and expertise consisting of
					</p>
					<ul>
						<li>
							A suitable construction related qualification at NVQ / SVQ level IV, such
							as a HND or above
						</li>
						<li>
							A minimum of 5 years of experience in the design of either domestic or
							non-domestic buildings (depending on the Scheme applied for)
						</li>
						<li>
							o Evidence of specific training in a relevant energy calculation
							methodology (SAP, SBEM or PHPP) or demonstration that at least 2
							building warrants have been granted based on the applicant’s energy
							calculations (SAP or iSBEM etc).
						</li>
					</ul>
				</li>
			</ul>

			<p>
				A detailed description of the{" "}
				<A
					target="_blank"
					href="/files/Membership-Criteria-and-Routes-to-Membership-v1.0.pdf">
					Membership Criteria and Routes to Membership
				</A>{" "}
				is available.
			</p>

			<p>
				<A
					href="/registration"
					class="rias inline-flex items-center rounded text-white bg-secondary box-border border border-transparent hover:bg-primary focus:ring-4 focus:ring-brand-medium shadow-xs font-medium leading-5 rounded-base text-sm px-4 py-2.5 focus:outline-none">
					You can apply to join now!
				</A>
			</p>
		</div>
	);
};
